module.exports = __webpack_public_path__ + "static/christian_sec1-9d451b97174a98903c4ea20446cbe134.png";